import React, { useState } from 'react'
import { img } from '../assets/assets'
import Countdown from 'react-countdown'

const About = () => {
    const [showExchangeDropdown, setShowExchangeDropdown] = useState(false)
    const [showMobileMenu, setShowMobileMenu] = useState(false)
    return (
        <>
            <div className="overflow-hidden">
                {/* <!-- <div className="bg-dark py-10">
				<div className="container">
					<div
						className="text-center
						d-flex
						justify-content-between
						space-x-10
						align-items-center">
						<div className="space-x-10 d-flex align-items-center">
							<lottie-player
								src="https://assets6.lottiefiles.com/private_files/lf30_kqshlcsx.json"
								background="transparent"
								speed="2"
								style="width: 50px; height: 50px"
								loop
								autoplay></lottie-player>
							<p className="color_white">
								Dark mode is now
								<span style="color: rgb(0, 255, 170)">Available </span>
							</p>
						</div>

						<div className="mode_switcher space-x-10">
							<a href="#" className="light d-flex align-items-center is_active">
								<i className="ri-sun-fill"></i> Light
							</a>
							<a href="#" className="dark d-flex align-items-center">
								<i className="ri-moon-fill"></i> Dark
							</a>
						</div>
					</div>
				</div>
			</div> --> */}

                <header className="header__1 js-header" id="header">
                    <div className="container">
                        <div className="wrap js-header-wrapper">
                            <div className="header__logo">
                                <a className="color_black" href="/">
                                    <img
                                        src={img.logos_seducetoken}
                                        alt="logo"
                                        id="logo_js_f"
                                    />
                                </a>
                            </div>

                            {/* <!-- ==================  --> */}
                            <div className="header__menu">
                                <ul className="d-flex space-x-20">
                                    <li className="has_popup">
                                        <a className="color_black" href="/">
                                            Home
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/about"
                                        >
                                            About Us
                                        </a>
                                    </li>
                                    <li>
                                        <a className="color_black" href="/team">
                                            Our Team
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/roadmap"
                                        >
                                            Roadmap
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href={img.whitepaper}
                                        >
                                            Whitepaper
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/ambassador"
                                        >
                                            Ambassadors
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/contact"
                                        >
                                            Contact
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            {/* <!-- ================= --> */}
                            <div className="header__btns">
                                <a
                                    className="btn btn-grad btn-sm"
                                    href="/dashboard"
                                >
                                    <img
                                        src={img.icons_settings}
                                        alt="Dashboard"
                                        height="20px"
                                        width="20px"
                                    />
                                    Dashboard
                                </a>
                            </div>

                            <div
                                className="header__burger js-header-burger"
                                onClick={() =>
                                    setShowMobileMenu(!showMobileMenu)
                                }
                            ></div>
                            {showMobileMenu ? (
                                <div className="header__mobile js-header-mobile">
                                    <div className="header__mobile__menu space-y-40">
                                        <ul className="d-flex space-y-20">
                                            <li className="has_popup">
                                                <a
                                                    className="color_black"
                                                    href="/"
                                                >
                                                    Home
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/about"
                                                >
                                                    About Us
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/team"
                                                >
                                                    Our Team
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/roadmap"
                                                >
                                                    Roadmap
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href={img.whitepaper}
                                                >
                                                    Whitepaper
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/ambassador"
                                                >
                                                    Ambassadors
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/contact"
                                                >
                                                    Contact
                                                </a>
                                            </li>
                                        </ul>
                                        <div className="space-y-20">
                                            <a
                                                className="btn btn-grad btn-sm"
                                                href="/dashboard"
                                            >
                                                Dashboard
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                </header>
                {/* <div
                    className="modal fade popup"
                    id="popup_bid_success"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                >
                    <div
                        className="modal-dialog modal-dialog-centered"
                        role="document"
                    >
                        <div className="modal-content">
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div className="modal-body space-y-20 p-40">
                                <h3 className="text-center">
                                    Your Bidding Successfuly Added
                                </h3>
                                <p className="text-center">
                                    your bid
                                    <span
                                        className="color_text txt
			                        _bold"
                                    >
                                        (16ETH)
                                    </span>
                                    has been listing to our database
                                </p>

                                <a href="" className="btn btn-dark w-full">
                                    
                                    Watch the listings
                                </a>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* <div
                    className="modal fade popup"
                    id="popup_bid"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                >
                    <div
                        className="modal-dialog modal-dialog-centered"
                        role="document"
                    >
                        <div className="modal-content">
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div className="modal-body space-y-20 p-40">
                                <h3>Place a Bid</h3>
                                <p>
                                    You must bid at least
                                    <span className="color_black">15 ETH</span>
                                </p>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="00.00 ETH"
                                />

                                <p>
                                    Enter quantity.
                                    <span className="color_green">
                                        5 available
                                    </span>
                                </p>
                                <input
                                    type="text"
                                    className="form-control"
                                    value="1"
                                />
                                <div className="hr"></div>
                                <div className="d-flex justify-content-between">
                                    <p> You must bid at least:</p>
                                    <p className="text-right color_black txt _bold">
                                        
                                        67,000 ETH
                                    </p>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <p> service free:</p>
                                    <p className="text-right color_black txt _bold">
                                        
                                        0,901 ETH
                                    </p>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <p> Total bid amount:</p>
                                    <p className="text-right color_black txt _bold">
                                        
                                        56,031 ETH
                                    </p>
                                </div>
                                <a
                                    href=""
                                    className="btn btn-primary w-full"
                                    data-toggle="modal"
                                    data-target="#popup_bid_success"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    
                                >
                                    
                                    Place a bid
                                </a>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* <div
                    className="modal fade popup"
                    id="popup_bid_success"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                >
                    <div
                        className="modal-dialog modal-dialog-centered"
                        role="document"
                    >
                        <div className="modal-content">
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div className="modal-body space-y-20 p-40">
                                <h3 className="text-center">
                                    Your Bidding Successfuly Added
                                </h3>
                                <p className="text-center">
                                    your bid
                                    <span
                                        className="color_text txt
			                        _bold"
                                    >
                                        (16ETH)
                                    </span>
                                    has been listing to our database
                                </p>

                                <a href="" className="btn btn-dark w-full">
                                    
                                    Watch the listings
                                </a>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* <div
                    className="modal fade popup"
                    id="popup_buy"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                >
                    <div
                        className="modal-dialog modal-dialog-centered"
                        role="document"
                    >
                        <div className="modal-content">
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div className="modal-body space-y-20 p-40">
                                <h3>Checkout</h3>
                                <p>
                                    You are about to purchase a
                                    <span className="color_black">
                                        SHADOW #7
                                    </span>
                                    from
                                    <span className="color_black">Lona</span>
                                </p>
                                <div className="space-y-10">
                                    <p>You pay</p>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="00.00 ETH"
                                    />
                                </div>
                                <div className="space-y-10">
                                    <p>
                                        Enter quantity.
                                        <span className="color_green">
                                            5 available
                                        </span>
                                    </p>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value="1"
                                    />
                                </div>

                                <div className="hr"></div>
                                <div className="d-flex justify-content-between">
                                    <p> You must bid at least:</p>
                                    <p className="text-right color_black txt _bold">
                                        
                                        67,000 ETH
                                    </p>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <p> service free:</p>
                                    <p className="text-right color_black txt _bold">
                                        
                                        0,901 ETH
                                    </p>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <p> Total bid amount:</p>
                                    <p className="text-right color_black txt _bold">
                                        
                                        56,031 ETH
                                    </p>
                                </div>
                                <a
                                    href="https://pay.sendwyre.com/"
                                    className="btn btn-primary
			                    w-full"
                                    aria-label="Close"
                                >
                                    Add funds
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="modal fade popup"
                    id="popup_bid_success"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                >
                    <div
                        className="modal-dialog modal-dialog-centered"
                        role="document"
                    >
                        <div className="modal-content">
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div className="modal-body space-y-20 p-40">
                                <h3 className="text-center">
                                    Your Bidding Successfuly Added
                                </h3>
                                <p className="text-center">
                                    your bid
                                    <span
                                        className="color_text txt
			                        _bold"
                                    >
                                        (16ETH)
                                    </span>
                                    has been listing to our database
                                </p>

                                <a href="" className="btn btn-dark w-full" >
                                    
                                    Watch the listings
                                </a>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* <!-- <div className="modal fade popup" id="popup_report" tabIndex={-1} role="dialog"
			    aria-hidden="true">
			    <div className="modal-dialog modal-dialog-centered" role="document">
			        <div className="modal-content">
			            <button type="button" className="close" data-dismiss="modal"
			                aria-label="Close">
			                <span aria-hidden="true">&times;</span>
			            </button>
			            <div className="modal-body space-y-20 p-40">

			                <h3>Report this item</h3>
			                <div className="hr"></div>
			                <div className="form-group space-y-10">
			                    <span className="variationInput">reason:</span>
			                    <select className="form-select custom-select"
			                        aria-label="Default select example">
			                        <option> Select a reason</option>
			                        <option>Purchase</option>
			                        <option>Support</option>
			                        <option>Technique</option>
			                        <option>Service Request</option>
			                    </select>
			                </div>
			                <div className="form-group space-y-10">
			                    <span className="variationInput">Additional comments:</span>
			                    <textarea name="..." cols="30" rows="10"
			                        placeholder="Explain why you are concerned about it."></textarea>
			                </div>
			                <a href="" className="btn btn-dark"> Report</a>
			            </div>
			        </div>
			    </div>
			</div> --> */}

                <div className="container">
                    <a href="/" className="btn btn-white btn-sm my-40">
                        Back to home
                    </a>
                    <div className="item_details">
                        <div className="row sm:space-y-20">
                            <div className="col-lg-6">
                                <img
                                    className="item_img imagecluster"
                                    src={img.logos_banner}
                                    alt=""
                                    width="600"
                                    height="600"
                                />
                            </div>
                            <div className="col-lg-6">
                                <div className="space-y-20">
                                    <h2>Seduce Token</h2>
                                    <div className="d-flex justify-content-between">
                                        {/* <!-- <div className="space-x-10 d-flex align-items-center">
										<div className="more">
											<div className="icon">
												<a href="#"> <i className="ri-more-fill"></i>
												</a>
											</div>
											<div className="dropdown__popup">
												<ul className="space-y-10">
													<li>
														<a href="#" className="space-x-10
															d-flex"
															data-toggle="modal"
															data-target="#popup_report">
															<i className="ri-flag-line"></i>
															<span> Report
															</span>
														</a>
													</li>
												</ul>
											</div>
										</div>
									</div> --> */}
                                    </div>
                                    <div className="dropdown">
                                        <button
                                            className="btn btn-white btn-sm
										dropdown-toggle"
                                            type="button"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                            onClick={() =>
                                                setShowExchangeDropdown(
                                                    !showExchangeDropdown
                                                )
                                            }
                                        >
                                            Exchanges
                                        </button>
                                        {showExchangeDropdown ? (
                                            <div className="dropdown-menu">
                                                <a
                                                    className="dropdown-item"
                                                    href="https://pancakeswap.finance/swap"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    <span>
                                                        <img
                                                            src={
                                                                img.icons_pankcake
                                                            }
                                                            width="20"
                                                            alt=""
                                                        />
                                                        View on Pancakeswap.
                                                    </span>
                                                    <i className="ri-external-link-line color_brand"></i>
                                                </a>
                                                <a
                                                    className="dropdown-item"
                                                    href="/dashboard"
                                                    target="_blank"
                                                >
                                                    <span>
                                                        <img
                                                            src={
                                                                img.icons_pinksale
                                                            }
                                                            width="20"
                                                            alt=""
                                                        />
                                                        View on Pinksale.
                                                    </span>
                                                    <i className="ri-external-link-line color_brand"></i>
                                                </a>
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                    <div className="box">
                                        <div className="space-y-20">
                                            <div
                                                className="d-flex justify-content-between
											mb-30_reset"
                                            >
                                                <ul
                                                    className="nav nav-tabs d-flex space-x-10 mb-30"
                                                    role="tablist"
                                                >
                                                    <li className="nav-item">
                                                        <a
                                                            className="btn btn-white btn-sm active"
                                                            data-toggle="tab"
                                                            href="#tabs-1"
                                                            role="tab"
                                                        >
                                                            About
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="hr"></div>
                                            <div className="tab-content">
                                                <div
                                                    className="tab-pane active"
                                                    id="tabs-1"
                                                    role="tabpanel"
                                                >
                                                    <p>
                                                        Seduce Token is a
                                                        Binance Smart Chain
                                                        token meant to serve as
                                                        utility token for a
                                                        revolutionary
                                                        Decentralized Platform
                                                        which will be a
                                                        one-stop-shop for all
                                                        adult entertainment
                                                        needs. The new &
                                                        innovative business
                                                        model will enable the
                                                        project to stand out of
                                                        ahead of all adult
                                                        entertainment projects
                                                        which come with huge
                                                        promises but fail to
                                                        deliver.
                                                    </p>
                                                </div>
                                                <div
                                                    className="tab-pane"
                                                    id="tabs-2"
                                                    role="tabpanel"
                                                >
                                                    <p>
                                                        We're exclusively
                                                        available on
                                                        <a href="/dashboard">
                                                            Pancakeswap
                                                        </a>
                                                        only!
                                                    </p>
                                                </div>
                                                <div
                                                    className="tab-pane space-y-20"
                                                    id="tabs-3"
                                                    role="tabpanel"
                                                >
                                                    <div
                                                        className="creator_item creator_card
													space-x-10"
                                                    >
                                                        <div className="avatars space-x-10">
                                                            <div className="media">
                                                                <div className="badge">
                                                                    <img
                                                                        src={
                                                                            img.icons_badge
                                                                        }
                                                                        alt=""
                                                                    />
                                                                </div>
                                                                {/* <!-- <a href="dashboard.html">
															<img src="assets/img/avatars/avatar_1.png" alt="Avatar"
																className="avatar
																	avatar-md">
														</a> --> */}
                                                            </div>
                                                            <div>
                                                                <p className="color_black">
                                                                    <b>
                                                                        Phase 1
                                                                    </b>
                                                                </p>
                                                                <span className="date color_text">
                                                                    ‣ Strategies
                                                                    and
                                                                    Planning.
                                                                    <br />
                                                                    ‣ Website
                                                                    launch aided
                                                                    by the
                                                                    whitepaper.
                                                                    <br />
                                                                    ‣ Point 3 ‣
                                                                    Inception of
                                                                    the telegram
                                                                    community.
                                                                    <br />
                                                                    ‣
                                                                    Orchestration
                                                                    of shilling
                                                                    contest for
                                                                    whitelist.
                                                                    <br />
                                                                    ‣ Launch of
                                                                    the social
                                                                    media
                                                                    handles
                                                                    (Twitter,
                                                                    and
                                                                    Instagram).
                                                                    <br />
                                                                    ‣ Audit(Tech
                                                                    Rate,
                                                                    Rugfreecoins
                                                                    and
                                                                    application
                                                                    for certik).
                                                                    <br />
                                                                    ‣ Giveaways.
                                                                    <br />
                                                                    ‣ Private
                                                                    presale with
                                                                    small
                                                                    hardcap
                                                                    promotions
                                                                    within
                                                                    cyrpto
                                                                    communities.
                                                                    <br />
                                                                    ‣ Onboard
                                                                    influencers.
                                                                    <br />
                                                                    ‣ AMAs
                                                                    <br />‣
                                                                    Presale.
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="creator_item creator_card
													space-x-10"
                                                    >
                                                        <div className="avatars space-x-10">
                                                            <div className="media">
                                                                <div className="badge">
                                                                    <img
                                                                        src={
                                                                            img.icons_badge
                                                                        }
                                                                        alt=""
                                                                    />
                                                                </div>
                                                                <a href="/dashboard">
                                                                    <img
                                                                        src={
                                                                            img.avatar_avatar2
                                                                        }
                                                                        alt="Avatar"
                                                                        className="avatar
																	avatar-md"
                                                                    />
                                                                </a>
                                                            </div>
                                                            <div>
                                                                <p className="color_black">
                                                                    Bid accepted
                                                                    <span className="color_brand">
                                                                        3 ETH
                                                                    </span>
                                                                    by
                                                                    <a
                                                                        className="color_black txt
																	_bold"
                                                                        href="/dashboard"
                                                                    >
                                                                        monir
                                                                    </a>
                                                                </p>
                                                                <span className="date color_text">
                                                                    Major
                                                                    marketing &
                                                                    advertising
                                                                    using funds
                                                                    from
                                                                    presales
                                                                    Pancakeswap
                                                                    Launch Coin
                                                                    market cap &
                                                                    coin gecko
                                                                    listings
                                                                    Trip
                                                                    sponsorship
                                                                    to LA (Lucky
                                                                    winners
                                                                    among the
                                                                    top 100
                                                                    buyers) NFT
                                                                    Airdrops to
                                                                    contest
                                                                    winners.
                                                                    Singing in
                                                                    adult
                                                                    content
                                                                    creators and
                                                                    pornstars
                                                                    Press
                                                                    Releases
                                                                    Beta Version
                                                                    Testing
                                                                    Application
                                                                    for CEX
                                                                    listing
                                                                    Augment
                                                                    Marketing
                                                                    Activations
                                                                    Though
                                                                    Associations
                                                                    with
                                                                    established
                                                                    companies
                                                                    within the
                                                                    industry
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="numbers">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="space-y-5">
                                                    <p className="color_text">
                                                        Presale Date
                                                    </p>
                                                    <h4>Coming soon.</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="hr2"></div>
                                    <div className="creators">
                                        <div className="row">
                                            {/* <!-- <div className="col-lg-6">
											<div className="avatars space-x-5">
												<div className="media">
													<a href="dashboard.html">
														<img
															src="assets/img/avatars/avatar_3.png"
															alt="Avatar" className="avatar
															avatar-sm">
													</a>
												</div>
												<div>
													<a href="dashboard.html">
														<p className="avatars_name color_black">@ayoub_fennouni
															/ fouzi...</p>
													</a>
												</div>
											</div>
										</div> --> */}
                                            {/* <!-- <div className="col-lg-6">
											<div className="avatars space-x-5">
												<div className="media">
													<div className="badge">
														<img className="badge"
															src="assets/img/icons/Badge.svg"
															alt="">
													</div>
													<a href="dashboard.html">
														<img
															src="assets/img/avatars/avatar_2.png"
															alt="Avatar" className="avatar
															avatar-sm">
													</a>
												</div>
												<div>
													<a href="dashboard.html">
														<p className="avatars_name color_black">@makinzi_jamy...</p>
													</a>
												</div>
											</div>
										</div> --> */}
                                        </div>
                                    </div>
                                    <div className="d-flex space-x-20">
                                        <a
                                            href="https://pancakeswap.finance/swap"
                                            target="_blank"
                                            className="UIbtn btn-grad btn-lg"
                                            data-toggle="modal"
                                            rel="noreferrer"
                                        >
                                            Buy now
                                        </a>
                                        {/* <!-- <a href="dashboard.html" target="_blank" className="btn btn-grad btn-lg"
									data-toggle="modal"> Contact Us
								</a> --> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <footer className="footer__1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 space-y-20">
                                <div className="footer__logo">
                                    <a href="/">
                                        <img
                                            src={img.logos_seducetoken}
                                            alt="logo"
                                            id="logo_js_f"
                                        />
                                    </a>
                                </div>

                                <div>
                                    <ul className="footer__social space-x-10 mb-40">
                                        <li>
                                            <a href="https://instagram.com/seduce_token_official?utm_medium=copy_link">
                                                <i className="ri-instagram-line"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://twitter.com/seducetokenbsc">
                                                <i className="ri-twitter-line"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://discord.gg/ewekBsfU4B">
                                                <i className="ri-discord-line"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://t.me/seducetokenofficial">
                                                <i className="ri-telegram-line"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-2 col-6">
                                <h6 className="footer__title">Project</h6>
                                <ul className="footer__list">
                                    <li>
                                        <a href="/"> Home </a>
                                    </li>
                                    <li>
                                        <a href="/about">About us</a>
                                    </li>
                                    <li>
                                        <a href="/team"> Our Team</a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/roadmap"
                                        >
                                            Roadmap
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/ambassador">Ambassadors</a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-lg-2 col-6">
                                <h6 className="footer__title">Get help</h6>
                                <ul className="footer__list">
                                    <li>
                                        <a href="/contact">Contact Us</a>
                                    </li>
                                    <li>
                                        <a href="/dashboard" target="_blank">
                                            Buy Token
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-lg-2 col-6">
                                <h6 className="footer__title">Documents</h6>
                                <ul className="footer__list">
                                    <li>
                                        <a
                                            href={img.whitepaper}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Whitepaper
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <p className="copyright text-center">
                            © Seduce Token 2021. Created with love by
                            <a
                                href="https://theclusterco.com"
                                target="_blank"
                                rel="noreferrer"
                            >
                                TheCluster
                            </a>
                            .
                        </p>
                    </div>
                </footer>
            </div>
        </>
    )
}

export default About
